"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
// Default context does not mean much sense here
const context = React.createContext(undefined);
exports.BotsContextProvider = context.Provider;
exports.BotsContextConsumer = context.Consumer;
